/**
 * Colors palette
 */
export const BrandColorMain = '#00AEEF';
export const BrandColorMainLighter = '#ebf9f1';
export const BrandColorMainHover = '#4CC6F4';
export const BrandColorMainDarken = '#AFEAFF';
export const BrandColorMainLighten = '#34C6FC';
export const BrandSecondaryGreen = '#9CC16E';
export const BrandSecondaryMagenta = '#D42B5C';
export const BrandSecondaryColor = '#EAEEF4';
export const LightSoftBrandColor = '#AFEAFF';
export const BrandSoftSecondaryColor = '#EAEEF4';

export const ColorError = '#FF6B6E';
export const ColorWarning = '#E5B011';
export const ColorLink = '#34aaf2';
export const ColorGreenDark = '#404d46';
export const ColorBlueDark = '#00A5E3';
export const ColorGreenLight = '#59ffa7';

export const ColorGrey1 = '#434C5E';
export const ColorGrey2 = '#00A5E3';
export const ColorGrey3 = '#b2b2b2';
export const ColorGrey4 = '#EAEEF4';
export const ColorGrey5 = '#fafafa';
export const ColorGrey6 = '#f9f9f9';
export const ColorGrey7 = '#ccc';
export const ColorGrey8 = '#89909C';
export const ColorGrey9 = '#C7CACF';
export const ColorGreyLight1 = '#CECED5';
export const ColorGreyLight2 = '#ABBAC8';
export const ColorWhite = '#ffffff';

export const _137C = '#E5B011';
export const _311C = '#5bd9e5';
export const Aquamarine = '#08d6a1';
export const Azure = '#00a2ff';
export const BlueBlue = '#1c53cd';
export const SoftBlue = '#6CC7ff';
export const ButtonDown = '#00A5E3';
export const LightSoftGreen = '#ddffec';
export const ButtonHoverGreen = '#10e272';
export const ButtonHoverBlue = '#4CC6F4';
export const ButtonHoverPurple = '#a500bf';
export const ClearWhite = '#ffffff';
export const DarkPeach = '#e2844c';
export const FreshAsphalt = '#434C5E';
export const FreshAsphalt50 = 'rgba(67,76,94, 0.5)';
export const FreshAsphalt80 = 'rgba(67,76,94,0.8)';
export const FullBlack = '#000000';
export const Fury = '#FF6B6E';
export const LightFury = '#FFDADB';
export const LightFury80 = 'rgba(255,218,219,0.8)';
export const Green = '#00b956';
export const Blue = '#00AEEF';
export const Link = '#34aaf2';
export const NiceBlue = '#128ab2';
export const LightSoftBlue = 'rgba(0,174,239,0.8)';
export const LightBlue = '#EDF9FF';
export const Purple = '#731982';
export const LightPurple = '#ffeeff';
export const PurplePink = '#ac31c1';
export const BrandPurple = '#aa67c1';
export const PurpleRed = '#5b1168';
export const PurpleLight = '#821e93';
export const ReflexBlue = '#444189';
export const Salmon = '#ff6d6d';
export const SpbSky0 = '#EAEEF4';
export const SpbSky050 = '#fbfbfb';
export const SpbSky1 = '#ABBAC8';
export const SpbSky150 = '#EAEEF4';
export const SpbSky2 = '#CECED5';
export const SpbSky3 = '#434C5E';
export const SunflowerYellow = '#ffd700';
export const Tangerine = '#ff8800';
export const WarmPink = '#ef476f';
export const WarmRedC = '#FF6B6E';

/**
 * Border color
 */
export const borderColorDefault = BrandSecondaryColor;
export const borderColorDisabled = ColorGreyLight2;
export const borderColorDown = ColorGrey2;
export const borderColorError = ColorError;
export const borderColorHover = BrandColorMainHover;
export const borderColorLight = ColorGreyLight1;
export const borderColorNormal = BrandColorMain;
export const borderColorSeparate = '#E5E5E5';
export const borderColorSeparateLight = ColorGrey6;
export const borderColorSuccess = BrandColorMain;
export const borderColorWarning = ColorWarning;
export const borderColorFocus = BrandColorMain;

/**
 * Background color
 */
export const backgroundColorBlack = FullBlack;
export const backgroundColorDisabled = ColorGreyLight2;
export const backgroundColorDisabledDark = ColorGreyLight1;
export const backgroundColorDown = ColorGrey2;
export const backgroundColorError = ColorError;
export const backgroundColorHover = BrandColorMainHover;
export const backgroundColorHoverGreen = ButtonHoverGreen;
export const backgroundColorHoverNormal = ColorGreyLight2;
export const backgroundColorHoverOpacity = SpbSky150;
export const backgroundColorModal = ColorGrey4;
export const backgroundColorNormal = ColorGrey1;
export const backgroundColorSuccess = BrandColorMain;
export const backgroundColorSuccessLighter = BrandColorMainLighter;
export const backgroundColorWarning = ColorWarning;
export const backgroundColorAlert = Fury;
export const backgroundColorWhite = ColorWhite;
export const backgroundColorNoticeInfo = LightBlue;
export const backgroundColorGradientStart = BrandColorMainDarken;
export const backgroundColorGradientMiddle = BrandColorMain;
export const backgroundColorGradientEnd = BrandColorMainLighten;
export const backgroundToggleColorHover = LightSoftBlue;
export const backgroundIconColor = BrandColorMain;
export const backgroundProgressInactiveColor = ColorGrey4;
export const backgroundRangePickerInactiveColor = BrandSecondaryGreen;
export const backgroundInfoIconAlertColor = BrandColorMain;
export const backgroundPieTimeCharges = BrandSecondaryGreen;
export const backgroundPieMacroRegion = FreshAsphalt;
export const backgroundPieMacroRegionAndNotInHomeRegion = LightBlue;
/**
 * Text color
 */
export const textAuthCollapseColor = FreshAsphalt;
export const textColor = ColorGrey1;
export const textColorActive = ColorGrey1;
export const textColorDanger = ColorWhite;
export const textColorOpacity = FreshAsphalt80;
export const textColorSuccess = BrandColorMain;
export const textColorWarning = ColorWhite;
export const textColorWhite = ColorWhite;
export const textDisabledColor = ColorGrey1;
export const textFocusColor = ColorGrey1;
export const textLabelColor = ColorGrey1;
export const textLinkColor = ColorLink;
export const textInputLabelDefaultColor = ColorGrey8;
export const textInputLabelDisableColor = ColorGrey9;
export const textInputValueDefaultColor = ColorGrey1;
/**
 * Button colors
 */
export const buttonPrimaryBackgroundColor = BrandColorMain;
export const buttonPrimaryBackgroundDisabled = SpbSky1;
export const buttonPrimaryTextColorDisabled = ColorWhite;
export const buttonPrimaryBorderColorDisabled = ColorWhite;
export const buttonOutlineBorderColorDisabled = SpbSky1;
export const buttonOutlineTextColorDisabled = SpbSky1;

/**
 * DChat colors
 */
export const chatErrorBackgroundColor = DarkPeach;
export const chatClientBackGround = BrandColorMainDarken;
export const chatBackgroundHoverColor = ButtonHoverBlue;
export const chatBackgroundActiveColor = ColorBlueDark;

/**
 * Header colors
 */
export const headerBackgroundColorStart = ColorWhite;
export const headerBackgroundColorMiddle = ColorWhite;
export const headerBackgroundColorEnd = ColorWhite;
export const headerDividerColor = BrandColorMain;
export const headerDividerBorder = '0px';
export const headerTextColor = FreshAsphalt;
export const headerTextOpacity = 1;
export const headerTextHoverColor = BrandColorMain;
export const headerBorderColor = BrandColorMain;

export default {
    backgroundColorBlack,
    backgroundColorDisabled,
    backgroundColorDisabledDark,
    backgroundColorDown,
    backgroundColorError,
    backgroundColorHover,
    backgroundColorHoverGreen,
    backgroundColorHoverNormal,
    backgroundColorHoverOpacity,
    backgroundColorModal,
    backgroundColorNormal,
    backgroundColorNoticeInfo,
    backgroundColorSuccess,
    backgroundColorSuccessLighter,
    backgroundColorWarning,
    backgroundColorWhite,
    backgroundColorGradientStart,
    backgroundColorGradientMiddle,
    backgroundColorGradientEnd,
    backgroundProgressInactiveColor,
    backgroundRangePickerInactiveColor,
    backgroundInfoIconAlertColor,
    backgroundPieTimeCharges,
    backgroundPieMacroRegion,
    backgroundPieMacroRegionAndNotInHomeRegion,
    borderColorDefault,
    borderColorDisabled,
    borderColorDown,
    borderColorError,
    borderColorHover,
    borderColorLight,
    borderColorNormal,
    borderColorSeparate,
    borderColorSeparateLight,
    borderColorSuccess,
    borderColorWarning,
    textAuthCollapseColor,
    textColor,
    textColorActive,
    textColorDanger,
    textColorOpacity,
    textColorSuccess,
    textColorWarning,
    textColorWhite,
    textDisabledColor,
    textFocusColor,
    textLabelColor,
    textLinkColor,
    textInputLabelDefaultColor,
    textInputLabelDisableColor,
    textInputValueDefaultColor,
    borderColorFocus,
    buttonPrimaryBackgroundColor,
    buttonPrimaryBackgroundDisabled,
    buttonPrimaryTextColorDisabled,
    buttonPrimaryBorderColorDisabled,
    buttonOutlineBorderColorDisabled,
    buttonOutlineTextColorDisabled,
    backgroundToggleColorHover,
    BrandSecondaryColor,
    BrandSoftSecondaryColor,
    backgroundIconColor,
    chatClientBackGround,
    chatBackgroundActiveColor,
    chatErrorBackgroundColor,
    chatBackgroundHoverColor,
    LightSoftBrandColor,
    headerBackgroundColorStart,
    headerBackgroundColorMiddle,
    headerBackgroundColorEnd,
    headerDividerColor,
    headerDividerBorder,
    headerTextColor,
    headerTextOpacity,
    headerTextHoverColor,
    headerBorderColor,
};
